export default __webpack_public_path__ + "static/1642-e09188b59ce591b6e1dcd8b0df8a2da7.gif";